/* 
acquired by running:
query {
  brand: contentfulBrand(name: { eq: "TopCV.co.uk" }) {
    ...Brand
  }
}
*/

export const brand = {
  brand: {
    name: 'TopCV.co.uk',
    phoneNumber: '+44 (800) 0293 253',
    blogPrefix: 'career-advice',
    linkedIn: 'http://www.linkedin.com/company/topcvservices',
    twitter: 'topcvservices',
    facebook: 'http://www.facebook.com/topcvservices',
    youTube: null,
    instagram: 'https://www.instagram.com/topcvservices/',
    productionUrl: 'https://topcv.co.uk',
    alternateName: ['topcv', 'topcv.com'],
    parentOrganization: 'Talent Inc',
    defaultPrivacyEmail: "privacy@topcv.co.uk",
    logo: {
      file: {
        url: '//images.ctfassets.net/7thvzrs93dvf/3eFiH1llabNpFMroUIM9JY/0a87fea1c480869f1f5e8cff2684e7c1/black__1_.svg',
      },
    },
    whiteLogo: {
      file: {
        url: '//images.ctfassets.net/7thvzrs93dvf/4MBQYWpbE67bq1hSKn4Z2x/a5db300fbb15f0aa3af7472cfae71d89/white__1_.svg',
      },
    },
    favicon: {
      file: {
        url: '//assets.ctfassets.net/7thvzrs93dvf/4Gs4BSrDxRoolb4f1ky5My/256a84f101e8bb8c40912ed6182c0db6/topcv-favicon.ico',
      },
    },
    alternateHreflang: [
      {
        hreflang: 'en-ZA',
        baseUrl: 'https://za.topcv.com',
      },
      {
        hreflang: 'x-default',
        baseUrl: 'https://www.topcv.com',
      },
    ],
    rssFeedTitle: 'RSS Feed for TopCV',
    rssFeedHref: 'https://s3.amazonaws.com/resume.cdn/articles/rss-topcv.xml',
  },
}
